import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Store } from '@ngrx/store';

import { IAuroraState } from '@apps/aurora.state';
import { LanguageService } from '@common/services';
import { Its2Constants } from '@apps/its2/its2.constants';
import { CreateService } from '@apps/its2/models/create-service';

import { CsStepsSummaryBaseComponent } from '../../common/cs-steps-summary-base.component';

@Component({
    selector: 'aa-cs-step1-summary',
    templateUrl: './cs-step1-summary.component.html',
    styleUrls: [
        '../../create-service-summary/create-service-summary.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CsStep1SummaryComponent extends CsStepsSummaryBaseComponent implements OnInit
{
    @Input() cs: CreateService;
    public language: string;
    public labelKey: string;

    constructor (
        userLanguageService: LanguageService,
        protected store: Store<IAuroraState>,
    )
    {
        super(store);

        this.language = userLanguageService.language;
    }

    ngOnInit (): void
    {
        this.labelKey = Its2Constants.getUrgencyLabelKey(this.cs.step1.urgency);
    }
}
